import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import Header from'../Component/Header'
const Admission = () => {  
  useEffect(() => {
    document.title = ' Admission - St. Josephs School Quadian Punjab';  
}, []); 
  return (
     <> 
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Admission</li>
                 <li>Admission</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2>Admission</h2>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12"> 
                     <p> Admission is welcomed mainly to the Nursery class. When there are too many applicants to the Nursery class the school management may adapt a system of drawing lots to maintain maximum impartiality in granting admission. The management reserves its right to determine its own criterion for deciding the management and other quota of seats as the school is an unaided minority educational institution totally exempt from the RTE Act, 2009, and is under the constitutional purview of the minority rights.</p>
                     <p>There shall be written test followed by an interview for admission to any class except for the Nursery Class. Selection will be strictly on merit, subject to the availability of seats in each class. The decision of the school authorities regarding registration and admission will be final. There is no specific syllabus for the Entrance test to any class. However, the criterion is to have the necessary knowledge based on which the students can continue his/her studies as per the ICSE/CBSE/PSEB curriculum and syllabus, in the class to which the admission is sought. The test will be conducted according to the standard of the school, based on the subjects taught in the previous classes.</p>
                     </div>
                </div> 
            </div>
        </div>
     </>
  )
}

export default Admission

